import { useNavigate } from "react-router-dom";
import { ArrowRight, RotateCcw } from "lucide-react";
import { money } from "../lib/api";
import { LongDistanceNote } from "./LongDistanceNote";

const Stat = ({ label, value, testid }) => (
  <div className="bg-white border border-slate-200 px-3 py-3">
    <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">{label}</div>
    <div className="font-display font-bold text-slate-900 text-xl mt-1" data-testid={testid}>{value}</div>
  </div>
);

export const QuoteResult = ({ result, onReset }) => {
  const navigate = useNavigate();
  const book = () => {
    const p = new URLSearchParams(Object.entries(result.input).map(([k, v]) => [k, String(v)]));
    navigate(`/register?${p.toString()}`);
  };
  return (
    <div className="p-5 sm:p-6 rise" data-testid="quote-result">
      <div className="font-mono text-xs text-slate-600 tracking-wide" data-testid="quote-result-route">
        {result.origin.city}, {result.origin.state} {result.origin.zip} <span className="text-orange-600">→</span> {result.destination.city}, {result.destination.state} {result.destination.zip}
      </div>
      <div className="mt-4 flex items-end gap-3">
        <div className="font-display font-black text-brand-600 text-5xl sm:text-6xl leading-none" data-testid="quote-result-price">{money(result.estimate)}</div>
        <div className="pb-1.5 font-mono text-xs text-slate-600" data-testid="quote-result-rate">{result.breakdown?.minimum_applied ? "minimum charge" : `$${Number(result.breakdown?.rate_per_mile || 0).toFixed(2)}/mile`}</div>
      </div>
      <div className="mt-5 grid grid-cols-2 gap-2">
        <Stat label="Distance" value={`${result.miles.toLocaleString()} mi`} testid="quote-result-miles" />
        <Stat label="Est. transit" value={`${result.transit_days_min}–${result.transit_days_max} days`} testid="quote-result-days" />
      </div>
      <LongDistanceNote quote={result} testid="quote-long-distance" />
      <p className="mt-4 text-xs text-slate-600 leading-relaxed border-l-2 border-amber-500 pl-3" data-testid="quote-result-disclaimer">{result.disclaimer}</p>
      <button onClick={book} className="btn-amber w-full h-12 mt-5 text-base" data-testid="quote-book-button">
        Book this shipment <ArrowRight className="w-4 h-4" />
      </button>
      <button onClick={onReset} className="mt-3 w-full flex items-center justify-center gap-2 text-xs font-mono uppercase tracking-wider text-slate-600 hover:text-brand-600" data-testid="quote-reset-button">
        <RotateCcw className="w-3 h-3" /> Edit quote
      </button>
    </div>
  );
};
